import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYourtravelDotTvComponent } from './simple-icons-yourtravel-dot-tv.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYourtravelDotTvComponent ],
    exports:      [ SimpleIconsYourtravelDotTvComponent ],
    bootstrap:    []
})
export class SimpleIconsYourtravelDotTvModule {}
